import { ReactElement } from 'react'

import { Select, Spin } from 'antd'

import { getKeywordsSearch } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { SEARCH_RESULTS_PER_QUERY } from 'configuration/typeahead'
import { titleCase } from 'helpers/formatting'
import { useTypeahead } from 'hooks'
import { KeywordSearchResult } from 'types'

interface Props {
    value?: string
    onChange: (value: string) => void
}

const KeywordSearchSelect = ({ value, onChange }: Props): ReactElement => {
    const [options, loading, onSearch, resetLoadingState] =
        useTypeahead<KeywordSearchResult>({
            apiSearchFunc: (query) =>
                getKeywordsSearch(
                    {
                        limit: SEARCH_RESULTS_PER_QUERY,
                        text__icontains: query.trim(),
                    },
                    { headers: { noCount: true } }
                ),
            optionFormatter: (keyword) => ({
                value: keyword.id,
                label: keyword.text,
                metadata: `${
                    keyword.campaign__profile__country_code
                } | ${titleCase(keyword.match_type || '')} | ${
                    keyword.campaign__name
                }`,
            }),
        })

    return (
        <Select
            filterOption={false}
            placeholder="Search Keywords..."
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            onSelect={resetLoadingState}
            showSearch
            style={{ width: '100%' }}
            value={value}
        >
            {options.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label} <i>({option.metadata})</i>
                </Select.Option>
            ))}
        </Select>
    )
}

export default KeywordSearchSelect
